import { DatePipe, NgOptimizedImage, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { UserOrder } from '../../../models/shopping';
import { FileurlPipe } from '../../../pipes/fileurl.pipe';
import { ShoppingCartItemImagePipe } from '../../../pipes/shopping/shopping-cart-item-image-pipe';
import { Price } from '../../common/price/price';

@Component({
  selector: 'app-user-order-list-item',
  imports: [
    DatePipe,
    NgOptimizedImage,
    ShoppingCartItemImagePipe,
    FileurlPipe,
    NgStyle,
    Price,
  ],
  templateUrl: './user-order-list-item.html',
  styleUrl: './user-order-list-item.scss',
})
export class UserOrderListItem {
  @Input({ required: true }) data!: UserOrder;
}
